(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopify-seccion-producto-cod"] && !Shopify.designMode) return;
  try {
    
  function codProductInit(root) {
    var variantDataEl = root.querySelector('[data-cod-variant-data]');
    if (!variantDataEl) return;
    var variants = JSON.parse(variantDataEl.textContent);
    var selected = {};

    root.querySelectorAll('[data-option-selected]').forEach(function (el) {
      var opt = el.closest('[data-option-position]');
      if (opt) selected[opt.getAttribute('data-option-position')] = el.textContent.trim();
    });

    function findVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return Object.keys(selected).every(function (pos) {
          return opts[parseInt(pos, 10) - 1] === selected[pos];
        });
      });
    }

    function money(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    }

    function updateUI(variant) {
      if (!variant) return;
      var priceEl = root.querySelector('[data-cod-price]');
      var comparePriceEl = root.querySelector('[data-cod-compare-price]');
      var savingsBadge = root.querySelector('[data-cod-savings-badge]');
      var savingsAmount = root.querySelector('[data-cod-savings-amount]');
      var variantIdInput = root.querySelector('[data-cod-variant-id]');
      var addBtn = root.querySelector('[data-cod-add-to-cart]');
      var addBtnText = root.querySelector('[data-cod-add-to-cart-text]');

      if (priceEl) priceEl.textContent = money(variant.price);

      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (comparePriceEl) {
        comparePriceEl.hidden = !hasCompare;
        comparePriceEl.textContent = hasCompare ? money(variant.compare_at_price) : '';
      }
      if (savingsBadge) {
        savingsBadge.hidden = !hasCompare;
        if (hasCompare && savingsAmount) savingsAmount.textContent = money(variant.compare_at_price - variant.price);
      }

      if (variantIdInput) {
        variantIdInput.value = variant.id;
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addBtnText) addBtnText.textContent = variant.available ? addBtnText.dataset.label || addBtnText.textContent : 'Agotado';
      }

      if (variant.featured_media && variant.featured_media.id) {
        var slide = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (slide) {
          root.querySelectorAll('.cod-gallery__slide').forEach(function (s) { s.hidden = true; s.classList.remove('is-active'); });
          slide.hidden = false;
          slide.classList.add('is-active');
          root.querySelectorAll('.cod-gallery__thumb').forEach(function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-target-media') === String(variant.featured_media.id));
          });
        }
      }
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-option-value]');
      if (opt) {
        var pos = opt.getAttribute('data-option-position');
        selected[pos] = opt.getAttribute('data-option-value');

        root.querySelectorAll('[data-option-position="' + pos + '"]').forEach(function (btn) {
          btn.classList.toggle('is-selected', btn === opt || (btn.hasAttribute('data-option-value') && btn.getAttribute('data-option-value') === selected[pos]));
        });
        var label = root.querySelector('.cod-option[data-option-position="' + pos + '"] [data-option-selected]');
        if (label) label.textContent = selected[pos];

        updateUI(findVariant());
        return;
      }

      var thumb = e.target.closest('[data-target-media]');
      if (thumb) {
        var id = thumb.getAttribute('data-target-media');
        root.querySelectorAll('.cod-gallery__slide').forEach(function (s) {
          var match = s.getAttribute('data-media-id') === id;
          s.hidden = !match;
          s.classList.toggle('is-active', match);
        });
        root.querySelectorAll('.cod-gallery__thumb').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cod-product-section').forEach(codProductInit);
  });
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.cod-product-section');
    if (root) codProductInit(root);
  });

  } catch(e) { console.error(e); }
})();
})();
